export default __webpack_public_path__ + "static/media/jbira_pasiata_449.e487576c.jpg";